import { UNIFIED_FEED_DOMAIN_GLOBAL } from 'constants';
import makeRequest from '../../utils/makeRequest';
import { createSlug, getSiteDomain } from '../../utils/common';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { getWeatherUrl } from './config';
import { getNestedValue } from '../../../src/routes/newslisting/layouts/config/AqiConfig';
import utils from './WeatherUtil';

const reducerName = 'weather';

const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');

function weatherData(data, id, aqi) {
  return {
    type: RECEIVE_DATA,
    payload: {
      weatherData: data,
      cityPostalId: id,
      currentCityAqiValue: aqi,
    },
  };
}

export function fetchWeatherData(params, isPrimeUser, forceCity) {
  const PRIME_FORCAST_LOCATION_URL = `${getSiteDomain()}/toiignorevp/forecast_location_country_ext.cms`;
  const NON_PRIME_FORCAST_LOCATION_URL = `${getSiteDomain()}/forecast_location_country_ext.cms`;
  const FORCAST_LOCATION_URL = isPrimeUser
    ? PRIME_FORCAST_LOCATION_URL
    : NON_PRIME_FORCAST_LOCATION_URL;

  const weatherUrls = [];
  const aqiCityName = createSlug(params.city, true);
  const isClientSide = typeof window !== 'undefined';
  const isIndia = isClientSide && window.geoinfo?.CountryCode === 'IN';

  if (params?.latitude && params?.longitude) {
    weatherUrls.push(
      makeRequest.get(
        `${getWeatherUrl(isPrimeUser)}?lat=${params.latitude}&lng=${
          params.longitude
        }&unit=m`,
      ),
    );
  }

  weatherUrls.push(
    makeRequest.get(
      `${FORCAST_LOCATION_URL}?countryCode=${params.countryCode}&query=${
        params.city
      }`,
    ),
  );

  if (isIndia) {
    weatherUrls.push(
      makeRequest.get(
        `${UNIFIED_FEED_DOMAIN_GLOBAL}/ufs-utility/utility/api/v1/aqi/get/city/detail?city=${aqiCityName}&pc=toi&pfm=web&client=toi&fv=1000`,
      ),
    );
  }
  if (!isIndia && forceCity) {
    weatherUrls.push(
      makeRequest.get(
        `${UNIFIED_FEED_DOMAIN_GLOBAL}/ufs-utility/utility/api/v1/aqi/get/city/detail?city=${aqiCityName}&pc=toi&pfm=web&client=toi&fv=1000`,
      ),
    );
  }

  return Promise.allSettled(weatherUrls);
}

export function getWeatherData(params, isPrimeUser = false) {
  return dispatch =>
    fetchWeatherData(params, isPrimeUser)
      .then(data => {
        const [weatherForecastData, weatherLocationData, weatherAqiData] = data;
        const currentCityAqiData =
          weatherAqiData.value &&
          weatherAqiData.value.data &&
          weatherAqiData.value.data.data &&
          weatherAqiData.value.data.data.componentMap &&
          Object.keys(weatherAqiData.value.data.data.componentMap).length > 0 &&
          weatherAqiData.value.data.data.componentMap['AQI-IN']?.sensorData &&
          getNestedValue(weatherAqiData.value.data.data, [
            'componentMap',
            'AQI-IN',
            'sensorData',
          ]);
        dispatch(
          weatherData(
            utils.filterData(weatherForecastData.value.data),
            utils.filterLocation(weatherLocationData.value.data),
            currentCityAqiData,
          ),
        );
      })
      .catch(error => {
        console.log(
          'Something went wrong while fetching weather data. Error details: ',
          error,
        );
      });
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA:
      return {
        ...state,
        weatherData: action.payload.weatherData,
        cityPostalId: action.payload.cityPostalId,
        currentCityAqiValue: action.payload.currentCityAqiValue,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
